import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Button, Grid, Typography} from '@material-ui/core';
import {ErrorMessage, FieldArray, useFormikContext} from 'formik'
import {makeStyles} from "@material-ui/core/styles";
import Divider from '@material-ui/core/Divider';
import PopOverDetails from "../../../../../PopOverInfo";
import AffinityInfoContext from "../../../../../../context/AffinityContext";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import MantineInputField from "../../../../FormikUtils/MantineInputField";
import MantineNumberField from "../../../../FormikUtils/MantineNumberField";

const useStyles = makeStyles((theme) => ({
    fieldArrayButtons: {
        padding: "0",
        marginTop: "16px",
        minWidth: "20px",
        maxWidth: "20px"
    },
    fieldArrayButtonsDiv: {
        display: "flex",
        flexDirection: "row",
        width: "48px",
        justifyContent: "space-between"
    },
    errorMessage: {
        color: "red",
        fontSize: "10px",
        textAlign: "center",
        marginTop: "4px"
    },
    declaracionTitle: {
        fontFamily: 'Montserrat',
        fontSize: 12,
        textAlign: "center"
    },
    priceTitle: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 18,
        color: "#fff"
    },
    priceText: {
        fontFamily: 'EncodeSansBold',
        fontSize: 32,
        color: "#fff"
    },
    boxPrice: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "120px",
        margin: "8px 0px",
        backgroundColor: "#BB0D66"
    },
    coberturasTable: {
        padding: theme.spacing(1),
    },
    tableHeader: {
        fontFamily: 'EncodeSansBold',
        fontSize: 18
    },
    tableRowLabel: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 14
    },
    dataText: {
        fontFamily: 'EncodeSansRegular',
        textAlign: "center",
        fontSize: 18
    },

}));


export default function SolicitudFormMobile(props) {
    const classes = useStyles();
    const {
        formField: {
            detalleEquipoElectronico: {
                descripcionElectronico,
                sumaAseguradaElectronico,
                codigoElectronico,
                codigoGrupoElectronico
            },
            detalleBicicletas: {
                descripcionBicicletas,
                sumaAseguradaBicicletas,
                codigoBicicletas,
                codigoGrupoBicicletas
            },
            detalleMonopatines: {
                descripcionMonopatines,
                sumaAseguradaMonopatines,
                codigoMonopatines,
                codigoGrupoMonopatines
            },
        },
        cotResponse,
        finalValues
    } = props;

    const {coberturasInfo, coveragesToFilter} = useContext(AffinityInfoContext);
    const {values, errors} = useFormikContext();
    const [sumasAseguradasDetails, setSumasAseguradasDetails] = useState(
        {bicicletas: 0, monopatines: 0, electronicos: 0}
    );

    const viviendasDict = {
        '1021': 'Casa de ocupación permanente',
        '1022': 'Departamento de ocupación permanente',
        '1023': 'Vivienda en barrio cerrado',
        '1024': 'Vivienda/Departamento de ocupación transitoria',
    };

    function currencyFormat(numString) {
        numString = numString.toString().replace(/\./g, "")
        numString = numString.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return numString
    }

    const equipoElectronicoVacio = {
        [descripcionElectronico.name]: '',
        [sumaAseguradaElectronico.name]: '',
        [codigoElectronico.name]: 201,
        [codigoGrupoElectronico.name]: 34,
    };
    const bicicletasVacio = {
        [descripcionBicicletas.name]: '',
        [sumaAseguradaBicicletas.name]: '',
        [codigoBicicletas.name]: 209,
        [codigoGrupoBicicletas.name]: 31,
    };
    const monopatinesVacio = {
        [descripcionMonopatines.name]: '',
        [sumaAseguradaMonopatines.name]: '',
        [codigoMonopatines.name]: 210,
        [codigoGrupoMonopatines.name]: 31,
    };

    const checkError = (prod) => {
        let prodName;
        if (prod === 1) prodName = "detalleBicicletas"
        if (prod === 2) prodName = "detalleMonopatines"
        if (prod === 3) prodName = "detalleEquipoElectronico"

        if (errors[prodName] !== undefined)
            return (errors[prodName].includes("Las sumas declaradas deben coincidir con las aseguradas"))
        else
            return false
    }

    useEffect(() => {
        finalValues.coberturas.map((cob) => {
            if (cob.numeroCobertura === "48") {
                let obj = sumasAseguradasDetails
                obj.bicicletas = cob.sumaAsegurada
                setSumasAseguradasDetails(obj)
            }
            if (cob.numeroCobertura === "49") {
                let obj = sumasAseguradasDetails
                obj.monopatines = cob.sumaAsegurada
                setSumasAseguradasDetails(obj)
            }
            if (cob.numeroCobertura === "26") {
                let obj = sumasAseguradasDetails
                obj.electronicos = cob.sumaAsegurada
                setSumasAseguradasDetails(obj)
            }
        })
    }, []);

    const buttonsToShow = (index, length, arrayHelpers, emptyArray) => {
        if (length === 1) {
            return (<Grid item xs={2}>
                <Button variant='outlined' size="small"
                        style={{padding: "0", marginTop: "16px", minWidth:"48px", maxWidth:"48px"}}
                        onClick={() => arrayHelpers.push(emptyArray)}>
                    <AddIcon/>
                </Button>
            </Grid>)
        } else if (index !== length - 1) {
            return (<Grid item xs={2}>
                <Button variant='outlined' size="small"
                        style={{padding: "0", marginTop: "16px", minWidth:"48px", maxWidth:"48px"}}
                        onClick={() => arrayHelpers.remove(index)}>
                    <RemoveIcon/>
                </Button>
            </Grid>)
        } else {
            return (
                <Grid item xs={2}>
                    <div className={classes.fieldArrayButtonsDiv}>
                        <Button variant='outlined' size="small"
                                className={classes.fieldArrayButtons}
                                onClick={() => arrayHelpers.remove(index)}>
                            <RemoveIcon/>
                        </Button>
                        <Button variant='outlined' size="small"
                                className={classes.fieldArrayButtons}
                                onClick={() => arrayHelpers.push(emptyArray)}>
                            <AddIcon/>
                        </Button>
                    </div>
                </Grid>
            )
        }
    }

    return (
        <React.Fragment>
            <Grid container direction='column'>
                <Grid item container spacing={3} direction='column' className={classes.coberturasTable}>
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        margin: "8px 24px",
                    }}>
                        <Typography className={classes.tableHeader}>Cobertura</Typography>
                        <Typography className={classes.tableHeader}>Suma Asegurada</Typography>
                    </div>
                    <FieldArray name='coberturas'>{() => (
                        finalValues.coberturas
                            .filter(cob => !coveragesToFilter.includes(cob.numeroCobertura))
                            .map((item) => (
                                <Fragment>
                                    <div style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        margin: "4px 8px 4px 24px",
                                    }}>
                                        <div style={{width: "50%"}}>
                                            <Typography className={classes.tableRowLabel}>
                                                {coberturasInfo[item.numeroCobertura].descripcion}
                                            </Typography>
                                        </div>
                                        <div style={{
                                            width: "30%", display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "right",
                                        }}>
                                            <Typography
                                                className={classes.tableRowLabel}>$ {currencyFormat(parseInt(item.sumaAsegurada))}</Typography>
                                        </div>
                                        <div style={{width: "15%"}}>
                                            <PopOverDetails
                                                descripcion={coberturasInfo[item.numeroCobertura].descripcionCompleta}/>
                                        </div>
                                    </div>

                                    {item.numeroCobertura === '48' &&
                                    <>
                                        <Typography className={classes.declaracionTitle}
                                                    style={{margin: "0px 16px 8px 16px"}}>
                                            Declaración de objetos asegurados bajo la cobertura "Robo de Bicicletas"
                                        </Typography>

                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0 8px 16px 8px",
                                        }}>
                                            <FieldArray name='detalleBicicletas'>{(arrayHelpers) => (
                                                values.detalleBicicletas.map((item, index) => (
                                                    <Grid key={index} item container spacing={2} direction='row'
                                                          style={{alignItems: "center", justifyContent: "center"}}>
                                                        <Grid item xs={4}>
                                                            <MantineInputField
                                                                name={`detalleBicicletas[${index}].${descripcionBicicletas.name}`}
                                                                label={descripcionBicicletas.label}
                                                                withAsterisk
                                                                size="sm"
                                                                styles={{
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <MantineNumberField
                                                                name={`detalleBicicletas[${index}].${sumaAseguradaBicicletas.name}`}
                                                                label={sumaAseguradaBicicletas.label}
                                                                styles={{
                                                                    input: {textAlign: "right", fontSize: "12px"},
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                                size="sm"
                                                                withAsterisk
                                                            />
                                                        </Grid>

                                                        {buttonsToShow(index, values.detalleBicicletas.length, arrayHelpers, bicicletasVacio)}
                                                    </Grid>
                                                ))
                                            )}</FieldArray>
                                            {checkError(1)
                                            &&
                                            <>
                                                <ErrorMessage name='detalleBicicletas'
                                                              render={msg => <div
                                                                  className={classes.errorMessage}>{msg}</div>}/>
                                                <p className={classes.errorMessage}> ($ {sumasAseguradasDetails.bicicletas})</p>
                                            </>}
                                        </div>
                                    </>}

                                    {item.numeroCobertura === '49' &&
                                    <>
                                        <Typography className={classes.declaracionTitle}
                                                    style={{margin: "0px 16px 8px 16px"}}>
                                            Declaración de objetos asegurados bajo la cobertura "Robo de Monopatines"
                                        </Typography>

                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0 8px 16px 8px",
                                        }}>
                                            <FieldArray name='detalleMonopatines'>{(arrayHelpers) => (
                                                values.detalleMonopatines.map((item, index) => (
                                                    <Grid key={index} item container spacing={2} direction='row'
                                                          style={{alignItems: "center", justifyContent: "center"}}>
                                                        <Grid item xs={4}>
                                                            <MantineInputField
                                                                name={`detalleMonopatines[${index}].${descripcionMonopatines.name}`}
                                                                label={descripcionMonopatines.label}
                                                                withAsterisk
                                                                size="sm"
                                                                styles={{
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <MantineNumberField
                                                                name={`detalleMonopatines[${index}].${sumaAseguradaMonopatines.name}`}
                                                                label={sumaAseguradaMonopatines.label}
                                                                styles={{
                                                                    input: {textAlign: "right", fontSize: "12px"},
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                                size="sm"
                                                                withAsterisk
                                                            />
                                                        </Grid>

                                                        {buttonsToShow(index, values.detalleMonopatines.length, arrayHelpers, monopatinesVacio)}
                                                    </Grid>
                                                ))
                                            )}</FieldArray>
                                            {checkError(2)
                                            &&
                                            <>
                                                <ErrorMessage name='detalleMonopatines'
                                                              render={msg => <div
                                                                  className={classes.errorMessage}>{msg}</div>}/>
                                                <p className={classes.errorMessage}> ($ {sumasAseguradasDetails.monopatines})</p>
                                            </>}
                                        </div>
                                    </>}

                                    {item.numeroCobertura === '26' &&
                                    <>
                                        <Typography className={classes.declaracionTitle}
                                                    style={{margin: "0px 16px 8px 16px"}}>
                                            Declaración de objetos asegurados bajo la cobertura "Robo de objetos
                                            varios"
                                        </Typography>

                                        <div style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            margin: "0 8px 16px 8px",
                                        }}>
                                            <FieldArray name='detalleEquipoElectronico'>{(arrayHelpers) => (
                                                values.detalleEquipoElectronico.map((item, index) => (
                                                    <Grid key={index} item container spacing={2} direction='row'
                                                          style={{alignItems: "center", justifyContent: "center"}}>
                                                        <Grid item xs={4}>
                                                            <MantineInputField
                                                                name={`detalleEquipoElectronico[${index}].${descripcionElectronico.name}`}
                                                                label={descripcionElectronico.label}
                                                                withAsterisk
                                                                size="sm"
                                                                styles={{
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            <MantineNumberField
                                                                name={`detalleEquipoElectronico[${index}].${sumaAseguradaElectronico.name}`}
                                                                label={sumaAseguradaElectronico.label}
                                                                styles={{
                                                                    input: {textAlign: "right", fontSize: "12px"},
                                                                    label: {fontSize: "12px", letterSpacing: "-0.5px"}
                                                                }}
                                                                size="sm"
                                                                withAsterisk
                                                            />
                                                        </Grid>

                                                        {buttonsToShow(index, values.detalleEquipoElectronico.length, arrayHelpers, equipoElectronicoVacio)}
                                                    </Grid>
                                                ))
                                            )}</FieldArray>

                                            {checkError(3)
                                            &&
                                            <>
                                                <ErrorMessage name='detalleEquipoElectronico'
                                                              render={msg => <div
                                                                  className={classes.errorMessage}>{msg}</div>}/>
                                                <p className={classes.errorMessage}> ($ {sumasAseguradasDetails.electronicos})</p>
                                            </>}
                                        </div>
                                    </>}
                                    <Divider light style={{margin: "0px 16px"}}/>
                                </Fragment>
                            )
                        )
                    )}</FieldArray>

                    <Grid item container spacing={2} direction="column">
                        <Grid item container direction="row" spacing={1} justify='center' alignItems='baseline'>
                            <Grid item>
                                <Typography className={classes.tableHeader}>Tipo de vivienda:</Typography>
                            </Grid>
                            <Grid item>
                                <Typography
                                    className={classes.dataText}>{viviendasDict[values.tipoVivienda]}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <div className={classes.boxPrice}>
                    <Typography className={classes.priceTitle}>Cuota mensual:</Typography>
                    <Typography className={classes.priceText}>$ {cotResponse.premioMensual}</Typography>
                </div>
            </Grid>
        </React.Fragment>
    );
}
